// extracted by mini-css-extract-plugin
export default {"rte-link-selected":"element_rte-link-selected__oktOr","rte__table":"element_rte__table__aOWge","rte__td":"element_rte__td__pam9l"};